'use strict';

declare let $: any;

export class DisabledHelper {
  static disableInputElement(element: any, tag: string) {
    let disabledByList = $(element).attr('disabled-by-list') || '';
    if (disabledByList.indexOf(tag) != -1) return;
    
    disabledByList = disabledByList.split(',');
    disabledByList.push(tag);
    
    $(element).attr('disabled-by-list', disabledByList.join(',').replace(/^,+/, ""));
    
    this.updateDisabledState(element);
  }
  
  static enableInputElement(element: any, tag: string) {
    let disabledByList = $(element).attr('disabled-by-list') || '';
    if (disabledByList.indexOf(tag) == -1) return;
    
    disabledByList = disabledByList.split(',');
    disabledByList.splice(disabledByList.indexOf(tag), 1);
    
    $(element).attr('disabled-by-list', disabledByList.join(',').replace(/^,+/, ""));
    
    this.updateDisabledState(element);
  }
  
  static updateDisabledState(element: any) {
    if (this.hasDisablingState(element)) {
      $(element).attr('disabled', 'disabled').addClass('disabled');
    } else {
      $(element).removeAttr('disabled', 'disabled').removeClass('disabled');
    }
  }

  static hasDisablingState(element: any) {
    return !!($(element).attr('disabled-by-list') || '');
  }
}


// WEBPACK FOOTER //
// ./src/app/helpers/disabled-helper.ts